import {
  DateTypeInput,
  DateTypeProps,
} from '@/components/GeneralInputs/DateTypeInput';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { memo } from 'react';

type Props<TFieldValues extends PaymentRequestForm> = Omit<
  DateTypeProps<TFieldValues>,
  'datepickerProps'
> & {
  property: TransactionProperty;
};

const InnerDateTypeCell = <TFieldValues extends PaymentRequestForm>({
  control,
  inputId,
  property,
  name,
  rules,
}: Props<TFieldValues>) => {
  return (
    <DateTypeInput<TFieldValues>
      control={control}
      inputId={inputId}
      name={name}
      dateFormatType={property.dateFormatType}
      placeholder={property.placeholder}
      rules={rules}
    />
  );
};
InnerDateTypeCell.displayName = 'InnerDateTypeCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const DateTypeCell = memo(InnerDateTypeCell) as typeof InnerDateTypeCell;
DateTypeCell.displayName = 'DateTypeCell';
